// components/login/login.jsx (überarbeitete Version Bootstrap 5)

import React, { useState, useEffect } from "react";
import { useNavigate } from 'react-router';
import { useAuth } from '../context/AuthContext.jsx';

const Login = ({ handleLogin, handleLogout }) => {
  const [credentials, setCredentials] = useState({ user: '', pwd: '' });
  const [loginState, setLoginState] = useState(0); // 0=Init, 1=Waiting, 2=Success, 3=Failure
  const { accessToken } = useAuth();
  const navigate = useNavigate();

  const updateCredentials = ({ target }) => {
    setCredentials({
      ...credentials,
      [target.id]: target.value
    });
  };

  useEffect(() => {
    if (loginState === 2 && accessToken) {
      navigate('/objekte');
    }
  }, [accessToken, loginState]);

  useEffect(() => {
    if (loginState === 0) {
      setCredentials({ user: '', pwd: '' });
    }
  }, [loginState]);

  const startLogin = async () => {
    setLoginState(1);
    const loginResult = await handleLogin(credentials);
    setLoginState(loginResult);
    if (loginResult === 2) navigate('/objekte');
  };

  const startLogout = async () => {
    setLoginState(0);
    const logoutResult = await handleLogout();
    setLoginState(logoutResult);
  };

  return (
    <div className="container d-flex justify-content-center align-items-center min-vh-100">
      <div className="card shadow-sm p-4" style={{ maxWidth: '400px', width: '100%' }}>
        <h2 className="text-center mb-4">Login</h2>

        <div className="mb-3">
          <label htmlFor="user" className="form-label">Benutzer</label>
          <input
            type="text"
            id="user"
            className="form-control"
            value={credentials.user}
            onChange={updateCredentials}
            autoComplete="current-username"
          />
        </div>
        <div className="mb-3">
          <label htmlFor="pwd" className="form-label">Passwort</label>
          <input
            type="password"
            id="pwd"
            className="form-control"
            value={credentials.pwd}
            onChange={updateCredentials}
            autoComplete="current-password"
          />
        </div>

        <div className="d-flex justify-content-between mt-4">
          <button className="btn btn-primary" onClick={startLogin}>Login</button>
          <button className="btn btn-outline-secondary" onClick={startLogout}>Logout</button>
        </div>

        <div className="mt-3 text-center">
          {loginState === 1 && <div className="text-muted">Validierung läuft...</div>}
          {loginState === 2 && <div className="text-success">Erfolgreich eingeloggt!</div>}
          {loginState === 3 && <div className="text-danger">Benutzername oder Passwort falsch</div>}
        </div>
      </div>
    </div>
  );
};

export default Login;
